module.exports = __webpack_public_path__ + "img/IMG_9919.ffe8c9c1.jpg";